export function mapPermissionsToApi(
  allPermissions?: Record<string, Record<'value', string>[]>,
) {
  const permissionKeys: string[] = [];
  Object.keys(allPermissions ?? {}).forEach((key) => {
    const permissions = allPermissions?.[key] ?? [];
    permissions.forEach((permission) => {
      if (
        permission.value &&
        permission.value in permission &&
        (permission as any)[permission.value]
      ) {
        permissionKeys.push(permission.value);
      }
    });
  });
  return permissionKeys;
}
